<dv-form-wrapper>
  <dv-section
    [isExpanded]="true"
    [isCollapsable]="false"
    [isBorderRemoved]="true">
    <dv-signal-form
      [fieldTree]="fieldTree"
      [elements]="damageInformationElements" />
  </dv-section>
  <dv-section
    [title]="'DamageReport.Sections.IncidentDetails' | translate"
    [isExpanded]="true">
    <dv-signal-form
      [fieldTree]="fieldTree"
      [elements]="incidentDetailsElements" />
  </dv-section>
  <dv-section
    [title]="'DamageReport.Sections.DamageDetails' | translate"
    [isExpanded]="true">
    <dv-signal-form
      [fieldTree]="fieldTree"
      [elements]="damageDetailsElements()" />
  </dv-section>
  <dv-section
    [title]="'DamageReport.Sections.OtherVehicleDetails' | translate"
    [isExpanded]="true">
    <dv-signal-form [fieldTree]="fieldTree" [elements]="otherVehicleElements" />
  </dv-section>
  <dv-section
    [title]="'DamageReport.Sections.AdditionalInformation' | translate"
    [isExpanded]="true">
    <dv-signal-form
      [fieldTree]="fieldTree"
      [elements]="additionalInformationElements" />
  </dv-section>
</dv-form-wrapper>
<dv-save-panel
  [disableSave]="isSaveDisabled()"
  [labelCancel]="''"
  (save)="onSave()">
</dv-save-panel>
